define('plugin/paid-attributes/view/step/AttributeTotalsView',['require','marionette','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('marionette').CompositeView;
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * @class AttributeTotalsView
     */
    return Parent.extend({

        collectionEvents: {
            sync: 'safeRender'
        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        initialize: function () {
            Parent.prototype.initialize.apply(this);

            var bookingModel = this.getOption('bookingModel');

            this.listenTo(bookingModel, 'change:products', this.safeRender);
            this.listenTo(bookingModel, 'change:service', this.safeRender);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        getTemplate: function () {
            return '#paid_attribute_step_totals_view';
        },

        serializeData: function () {
            var service = this.getOption('bookingModel').get('service');

            if (!service) {
                return Parent.prototype.serializeData.apply(this);
            }

            var amount;
            var productsAmount;
            if (this.getOption('bookingModel').get('service').is_recurring) {
                amount = +service.price;
                productsAmount = +this.getProductsAmount();
            } else {
                amount = +service.price + this.getProductsAmount();
                if (amount && this.getOption('bookingModel').get('count')) {
                    amount *= this.getOption('bookingModel').get('count');
                }
            }

            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                    duration: +service.duration + this.getProductsDuration(),
                    amount: amount,
                    productsAmount: productsAmount,
                    hide_duration: service && service.hide_duration,
                    currency: service.currency,
                    service: service
                }
            );
        },

        getProductsDuration:function() {
            return this.getOption('bookingModel').get('products').reduce(function(total, product) { return total + +product['duration'] }, 0);
        },

        getProductsAmount:function() {
            //TODO take into account that products must not be multiplied by count
            return this.getOption('bookingModel').get('products').reduce(function(total, product) { return total + +product['price'] }, 0);
        }
    });

});
